import ProjectImg from "../../assets/img/project.jpg";
import ProjectImg2 from "../../assets/img/project2.jpg";
import ConsumptionChart from "./ConsumptionChart";
import CounterTypeTableHeader from "./CounterTypeTableHeader";
import useCustomState from "../../hooks/State";
import ConsumptionsTable from "./ConsumptionTable";
// import ListBuyers from "./ListBuyers";
// import ListCounterTypes from "./ListCounterTypes";

const Details = (props) => {
  const counterType = props.data.match.params.counterType;

  const categoryInfo = useCustomState({ name: "" });

  const categoryInfoChanged = (newInfo) => {
    categoryInfo.handleChange(newInfo);
  };

  return (
    <div
      style={{
        paddingLeft: "16px",
        paddingRight: "16px",
        paddingTop: "24px",
      }}
    >
      <CounterTypeTableHeader
        counterType={counterType}
        categoryInfoChanged={categoryInfoChanged}
      />
      <div style={{ marginBottom: "24px" }}>
        <ConsumptionChart
          counterType={counterType}
          categoryInfo={categoryInfo.value}
        />
      </div>
      <div style={{ marginBottom: "24px" }}>
        <ConsumptionsTable counterType={counterType} />
      </div>
    </div>
  );
};

export default Details;
